// @ts-strict-ignore
/**
 * @fileoverview hook to manage the media library
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { cacheKey } from "./constants";
import type { MediaLibraryParams, MediaQueryResult } from "./types";
import { isMediaQueryResult } from "./validators";

const addDateObject = (key: string, startDate: number, endDate: number) => {
  if (!startDate || !endDate) {
    return {};
  }

  return {
    [key]: { start_date: startDate, end_date: endDate },
  };
};

/**
 * fetch files from backend
 *
 * @param appGroupId - the current app group ID
 * @param page - the current page to fetch
 * @param query - the query to fetch with
 * @param config - the configuration for the call
 *
 * @returns the data from the fetch in a promise
 */
export const getFileList = reactQueryTableFetcherAdapter(
  cacheKey,
  async (
    signal: AbortSignal,
    { appGroupId, query, groupby, limit = 20, start = 0, sortby, sortdir }: MediaLibraryParams
  ): Promise<MediaQueryResult> => {
    const {
      edited_start_date: editedStartDate,
      edited_end_date: editedEndDate,
      created_start_date: createdStartDate,
      created_end_date: createdEndDate,
      "": searchQuery,
      ...rest
    } = query;

    const qs = serializeQueryObjects(
      {
        ...rest,
        ...addDateObject("edited", editedStartDate, editedEndDate),
        ...addDateObject("created", createdStartDate, createdEndDate),
        ...(searchQuery ? { "": searchQuery } : {}),
      },
      true
    );

    return await fetch(
      "/engagement/media_library_data",
      "GET",
      {
        groupby,
        query: qs,
        limit,
        start,
        app_group_id: appGroupId,
        sortby,
        sortdir,
      },
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isMediaQueryResult
);
